function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.6,4C9.3,4,8.9,4.1,8.6,4.2C9.1,3.8,9.6,3.5,10,3.3c0.4-0.1,0.7-0.1,0.8,0l0.5-0.5C10.8,2.4,10.1,2,9.3,2 C8.3,2,7.5,2.5,7,3.2C6.5,2.5,5.7,2,4.7,2C3.9,2,3.2,2.3,2.7,2.9l0.5,0.5c0.1-0.1,0.5-0.2,0.8,0c0.5,0.2,0.9,0.5,1.4,0.9 C5.1,4.1,4.7,4,4.4,4C2.8,4,1.5,5.3,1.5,6.9h0.6c0-0.4,0.9-0.9,2.2-1C4,6.1,3.8,6.3,3.6,6.5c-1.1,1.1-1.1,3,0,4.1L4,10.2 C3.7,9.9,4,8.8,4.9,7.9c0.9-0.9,1.6-1,1.7-1l0.7,0c0.1,0,0.8,0.1,1.7,1c0.9,0.9,1.2,2,0.9,2.3l0.5,0.5c1.1-1.1,1.1-3,0-4.1 C10.2,6.3,9.9,6.1,9.7,6c1.3,0,2.2,0.5,2.2,1h0.6C12.5,5.3,11.2,4,9.6,4z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.9,10.4L7.9,12l-1.9-0.4l0.1-1.1H7.9z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.2,9.8h1.7l0-0.6H6.2L6.2,9.8z",
  fill: "current"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.4,7.6l-0.1,0l-0.5,0l-0.1,0c-0.1,0-0.2,0.1-0.3,0.1l0,0.8h1.5l0-0.8C7.6,7.6,7.5,7.6,7.4,7.6z",
  fill: "current"
}));

function SvgVacation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacation);
export default __webpack_public_path__ + "static/media/vacation.5762f76e.svg";
export { ForwardRef as ReactComponent };